import React, { useEffect, useState } from 'react';
import { Alert, IconButton, LinearProgress, Snackbar } from '@mui/material';
import { Close } from '@mui/icons-material';

interface SnackbarAlertProps {
	severity: 'success' | 'error' | 'warning';
	open: boolean;
	onClose: () => void;
	alertMessage: string;
	testId?: string;
}

export const SnackbarAlert: React.FC<SnackbarAlertProps> = ({ severity, open, onClose, alertMessage, testId }) => {
	const [progress, setProgress] = useState(0);

	const handleAction = () => {
		const interval = setInterval(() => {
			setProgress((prevProgress) => prevProgress + 0.26);
		}, 10);

		const duration = setTimeout(() => {
			clearInterval(interval);
			setProgress(0);
		}, 5000);

		return () => {
			clearTimeout(duration);
		};
	};

	useEffect(() => {
		if (open && severity !== 'error') {
			handleAction();
		}
	}, [open]);

	const handleClose = () => {
		setProgress(0);
		onClose();
	};

	return (
		<Snackbar
			open={open}
			autoHideDuration={severity !== 'error' ? 5000 : null}
			onClose={handleClose}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
			data-testid={testId}
		>
			<Alert
				severity={severity}
				sx={{ width: '100%' }}
				action={
					severity === 'error' && (
						<IconButton size="small" onClick={handleClose} aria-label="Close Error Snackbar">
							<Close fontSize="small" />
						</IconButton>
					)
				}
			>
				{alertMessage}
				{severity !== 'error' && (
					<LinearProgress
						aria-label="Success countdown"
						variant="determinate"
						color={severity}
						value={progress}
						sx={{
							position: 'absolute',
							bottom: 0,
							left: 0,
							right: 0,
							borderRadius: 0,
						}}
					/>
				)}
			</Alert>
		</Snackbar>
	);
};
